<template>
    <div class="text-center font-weight-bold w-100">
        <div class="icon-item--rounded">
            <div class="icon-item--rounded__inner d-flex flex-column align-center justify-center" :style="'background-color:'+ bgColor +';'">
                <v-img :src="icon" contain max-height="52"></v-img>
                <p class="page-text--sm line-height-1 color-white mt-6 mt-lg-12" v-if="tit">
                    {{tit}}
                </p>
            </div>
        </div>
        <p class="page-text color-grey mt-8 mt-lg-14" v-if="sc">
            {{sc}}
        </p>
    </div>
</template>

<script>

export default{
    props : {
		bgColor : {type :String, default : ""},
		icon : {type :String, default : ""},
        tit : {type :String, default : ""},
		sc : {type :String, default : ""},
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
.icon-item--rounded{
	width: 100%;
	height: 0;
	position: relative;
	padding-top: 100%;
}
.icon-item--rounded__inner{
	position: absolute;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	top: 0;
	left: 0;
}
</style>